<!--基本信息-->
<template>
  <div class="basicInformation">
    <!--详细信息-->
    <div class="basicInforData flexBetween">
      <div
        class="baseicInforDatachild flexCenterColumn"
        :style="backImg('/huapu/powerRoom.png')"
      >
        <span class="pp"
          >配电房数量 <span class="yellowed">{{ roomCounts }}</span></span
        >
      </div>
      <div
        class="baseicInforDatachild flexCenterColumn"
        :style="backImg('/huapu/powerRoom.png')"
      >
        <span class="pp" style="margin-bottom: 15px;"
          >负荷设备数 <span class="yellowed">{{ DevicePower }}</span></span
        >
        <span class="pp"
          >负荷容量 <span class="yellowed">{{ newloadCapacity }}</span></span
        >
      </div>
      <div
        class="baseicInforDatachild flexCenterColumn"
        :style="backImg('/huapu/powerRoom.png')"
      >
        <span class="pp" style="margin-bottom: 15px;"
          >日最大需量(kw)
          <span class="yellowed">{{ basicInforData.nowDayDemand }}</span></span
        >
        <span class="pp"
          >月最大需量(kw)
          <span class="yellowed">{{
            basicInforData.nowMonthDemand
          }}</span></span
        >
        <span v-show="false">{{ nowUnit.id }}</span>
      </div>
    </div>
    <!--value-->
    <div class="basicInforValue flexBetween">
      <div class="basicInforValueChild flexCenterColumn">
        <div class="flexCenter  xuanzhuan">
          <img :src="imgName('/huapu/loadValue.png')" />
          <span class="percent">{{ realLoadRate }}%</span>
        </div>

        <span style="color: yellow;font-size: 14px; margin-top: 12px;">{{
          MacRealValue || 0
        }}</span>
        <span>实时负荷(KW)</span>
      </div>
      <div class="basicInforValueChild flexCenterColumn">
        <div class="flexCenter xuanzhuan">
          <img :src="imgName('/huapu/loadValue.png')" />
          <span class="percent">{{ realLoadRate2 }}%</span>
        </div>
        <span style="color: yellow;font-size: 14px; margin-top: 12px;">{{
          DayMaxLoad || 0
        }}</span>
        <span>本日最大值(KW)</span>
      </div>
      <div class="basicInforValueChild flexCenterColumn">
        <div class="flexCenter xuanzhuan">
          <img :src="imgName('/huapu/loadValue.png')" />
          <span class="percent">{{ realLoadRate3 }}%</span>
        </div>
        <span style="color: yellow;font-size: 14px; margin-top: 12px;">{{
          MonthMaxLoad || 0
        }}</span>
        <span>本月最大值(KW)</span>
      </div>
    </div>
  </div>
</template>
<script>
import resourcesStore from "@/cache/resourcesStore.js";
import request from "@/api/http.js";
export default {
  data() {
    return {
      DevicePower: 0, //负荷设备数
      roomCount: 0, //配电房数量
      basicInforData: {}, //详细信息
      MacRealValue: 0, //实时数据
      mapkey: "", //实时数据 请求参数
      setTime: "", //定时器
      DayMaxLoad: 0, //本日最大值
      MonthMaxLoad: 0, //本月最大值
      loadDeviceList: [],
      deviceNoToArchivesInfo: {},
      nowLoadDeviceFromname: "",
    };
  },
  beforeDestroy() {
    //销毁
    clearInterval(this.setTime);
  },
  watch: {
    nowUnit(nv, ov) {
      this.getLoadValue(nv.id);
      this.init();
    },
  },
  mounted() {
    this.getLoadValue(this.nowUnit.id);
    this.init();
  },
  computed: {
    nowUnit() {
      //总id
      return this.$store.unitStore.getters.getNowUnit;
    },
    loadCapacity() {
      //总负荷容量
      return this.$store.unitStore.getters.getLoadCount(this.nowUnit.id);
    },

    realLoadRate() {
      //本日最大值 百分比
      if (this.newloadCapacity != 0 && this.MacRealValue != 0) {
        return parseFloat(
          (this.MacRealValue / this.newloadCapacity) * 100
        ).toFixed(2);
      }
      return 0;
    },
    realLoadRate2() {
      //本日最大值 百分比
      if (this.newloadCapacity != 0 && this.DayMaxLoad != 0) {
        return parseFloat(
          (this.DayMaxLoad / this.newloadCapacity) * 100
        ).toFixed(2);
      }
      return 0;
    },
    realLoadRate3() {
      //本日最大值 百分比
      if (this.newloadCapacity != 0 && this.MonthMaxLoad != 0) {
        return parseFloat(
          (this.MonthMaxLoad / this.newloadCapacity) * 100
        ).toFixed(2);
      }
      return 0;
    },

    backImg() {
      //图片路径
      return this.$store.resourcesStore.getters.getBackgroudImageStyle;
    },
    imgName() {
      //图片名称
      return resourcesStore.getters.getResourcesByName;
    },
    nowReadDeviceTree() {
      //当前单位可查看虚拟设备树
      return this.$store.deviceStore.getters.getReadDeviceTreeByUnitId(
        this.nowUnit.id
      );
    },
    roomCounts() {
      //配电房数量，由当前单位下所有类型为配电房的虚拟设备组的数量决定，配电房下的配电房也算配电房
      var list = treeToList(this.nowReadDeviceTree, "next", (item) => {
        return item.hasOwnProperty("next");
      });
      return list.filter((item) => {
        return item.devicetype == 2;
      }).length;
    },
    newloadCapacity() {
      var count = 0;
      for (var i = 0, len = this.loadDeviceList.length; i < len; i++) {
        var item = this.loadDeviceList[i];
        var info = this.deviceNoToArchivesInfo[item.deviceno];
        if (!isempty(info) && !isempty(info.next)) {
          var target = info.next.find((it) => it.propertyCode == "Capacity");
          let target2 = info.next.find((it) => it.propertyCode == "edrl");
          if (!isempty(target) && !isempty(target.value)) {
            try {
              count += parseFloat(target.value);
            } catch (e) {}
          }
          if (!isempty(target2) && !isempty(target2.value)) {
            try {
              count += parseFloat(target2.value);
            } catch (e) {}
          }
        }
      }
      return parseInt(count);
    },
  },

  methods: {
    getLoadValue(unitId) {
      //获取单位相关的数据
      if (isempty(unitId)) {
        return;
      }
      //获取变压器负荷设备列表
      this.$api.deviceApi.getDeviceListByDeviceType(
        unitId,
        "load",
        (respon) => {
          console.log(respon, 11);
          this.loadDeviceList = respon;
          this.$api.archivesApi.getArchivesInfoByVirtualDeviceNos(
            respon.map((item) => item.deviceno).join(","),
            (tree) => {
              this.deviceNoToArchivesInfo = tree;
            }
          );
        }
      );
    },
    init() {
      var params = { unitId: this.nowUnit.id, type: "load" };
      //         unitId: B5A693FA77804BC8BE009D57D0E7A788
      // type: load
      request({
        url: "/virtualDevice/getDeviceListByDeviceType.do",
        method: "post",
        params,
      }).then((res) => {
        //负荷设备数
        if (res.success) {
          this.DevicePower = res.data.length;
        }
      });
      request({ url: "/power/countRoomCount.do", method: "get", params }).then(
        (res) => {
          //配电房数量
          this.roomCount = res.roomCount;
        }
      );

      //本日最大值
      this.$api.powerApi.getDayMaxLoad(
        this.nowUnit.id,
        new Date().getTime(),
        (res) => {
          this.DayMaxLoad = res;
        }
      );

      //本月最大值
      this.$api.powerApi.getMonthMaxLoad(
        this.nowUnit.id,
        new Date().getTime(),
        (res) => {
          this.MonthMaxLoad = res;
        }
      );

      //详细信息
      var params = { unitId: this.nowUnit.id };
      request({ url: "/demand/findDemand", method: "get", params }).then(
        (res) => {
          if (res.code == 200) {
            this.basicInforData = res.data;
          }
        }
      );

      this.getList(); // 获取实时值
      if (this.setTime) {
        clearInterval(this.setTime);
      }
      this.setTime = setInterval(() => {
        this.getList(); // 获取实时值
      }, 5000);
    },

    // 获取实时值
    getList() {
      //获取实时负荷
    },
  },
};
</script>

<style scoped>
.pp {
  white-space: nowrap;
}

.basicInformation .yellowed {
  color: yellow;
  font-weight: bold;
  font-size: 16px;
  margin-left: 5px;
}

@keyframes rotation {
  from {
    -webkit-transform: rotate(0deg);
  }

  to {
    -webkit-transform: rotate(360deg);
  }
}

.xuanzhuan img {
  /* animation: rotation 10s linear infinite; */
}

.basicInformation {
  width: calc(30% - 20px);
  padding: 10px;
  height: calc(100% - 20px);
  position: relative;
}

.details {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.details img {
  width: 0.3rem;
}

.basicInformation span {
  color: white;
  font-size: 12px;
  display: flex;
  align-items: center;
}

.details span {
}

.communicationState {
  display: flex;
  align-items: center;
  padding-top: 0.1rem;
}

.communicationState img {
  width: 0.3rem;
}

.communicationState span {
  padding-left: 0.1rem;
}

.dropDownBox {
  padding: 5px 0;
  margin: 5px 0;
  background-size: 100% 90%;
  background-repeat: no-repeat;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: flex-start;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.dropDownBox input {
  width: 50%;
  background-color: rgba(0, 0, 0, 0);
  color: white;
  outline: none;
  border: 0;
  border-bottom: 0.01rem solid yellow;
  border-radius: 0;
  line-height: 16px;
  font-size: 12px;
  margin-right: 5px;
}

.dropDownBox input:focus {
  border: 0;
  outline: none;
  background-color: #143a70;
  border-bottom: 0.01rem solid yellow;
  border-radius: 0;
  width: 50%;
}

.dropDownBox img {
  height: 22px;
}

.elAutoComplete {
  width: 100%;
}

.dropDownList {
  width: 40%;
  background-color: white;
  position: absolute;
  left: 28%;
  top: 30%;
  max-height: 25%;
  z-index: 999;
  overflow-y: overlay;
}

.dropDownList ul li {
  padding: 0 0 0.1rem 0.1rem;
}

.dropDownList ul li:nth-child(1) {
  padding-top: 0.1rem;
}

.dropDownList ul li:hover {
  background-color: rgba(0, 0, 0, 0.1);
}

.basicInforData {
  height: calc(100% * 0.3);
  margin-bottom: 50px;
}

.baseicInforDatachild {
  width: 30%;
  height: calc(100% - 8px);
  padding: 4px 0;
  background-repeat: no-repeat;
  background-size: 100%;
}

.baseicInforDatachild span {
}

.basicInforValue {
  height: calc((100% - 117px) * 0.7);
}

.basicInforValueChild {
  width: 30%;
  height: -webkit-fill-available;
}

.basicInforValueChild div {
  position: relative;
  width: 100%;
  height: 100%;
}

.basicInforValueChild div img {
  max-height: 100%;
  max-width: 100%;
}

.basicInforValueChild div img,
.basicInforValueChild div span {
  position: absolute;
}

.basicInforValueChild div .percent {
  color: yellow;
  font-size: 16px;
}
</style>
